import type { IconProps } from "./icon-types";

/**
 * 로켓(동체 + 창 + 좌우 핀 + 하단 불꽃). 실행/배포/시작 표시에 사용(제품 의미 부여는
 * 소비 앱의 semantic alias 책임).
 *
 * 커스텀 드로잉 — c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split
 * §아이콘). 24 그리드 / stroke 기반.
 */
export const RocketIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    {/* 동체 */}
    <path d="M12 2.5C14.5 5 16 8.5 16 12v5H8v-5c0-3.5 1.5-7 4-9.5Z" />
    {/* 창 */}
    <circle cx="12" cy="10" r="1.8" />
    {/* 좌우 핀 */}
    <path d="M8 13.5 5 16.5V20l3-2M16 13.5l3 3V20l-3-2" />
    {/* 불꽃 */}
    <path d="M10 17c0 2.5 1 4 2 5 1-1 2-2.5 2-5" />
  </svg>
);
